import React, { useState, useEffect } from 'react';
import AluminiHeader from './AluminiHeader';
import AluminiSidebar from './AluminiSidebar';
import AluminiHome from './AluminiHome';
import AluminiCommunication from './AluminiCommunication';
import AluminiProfile from './AluminiProfile';
import AluminiSettings from './AluminiSettings';
import WeeklyReportsUpload from '../../features/WeeklyReports';
import Mailbox from '../../../components/Mailbox/Mailbox';
import PublicChat from '../../../components/PublicChat/PublicChat';
import AluminiCRM from '../../../components/crm/AluminiCRM';
import IntroToCostingAndManAcc from '../../../components/training/IntroToCostingAndManAcc';
import DesignABusiness from '../../../components/training/DesignABusiness';
import ProgramHealthCheckDashboard from '../../../components/Programs/ProgramHealthCheckDashboard';
import GrantBasics from '../../../components/Funding/GrantBasics';
import ApplicationTutorials from '../../../components/Funding/ApplicationTutorials';
import ScalingModules from '../../../components/Modules/ScalingModules';
import LogoutConfirmation from '../../../components/ui/LogoutConfirmation';
import { useAuth } from '../../../context/AuthContext';
import AlumniReports from '../../features/AlumniReports';
import HealthDashboard from '../../../components/HealthCheck/HealthDashboard';
import DocumentBankPage from '../../../components/DocumentBank/DocumentBankPage';
import SettingsPageComponent from '../../main/SettingsPage';

const AlumniTraining = () => {
  const [activeCourse, setActiveCourse] = useState('business');
  const [userRole] = useState('alumni');

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 md:py-8 lg:px-8">
        <div className="mb-6 md:mb-8">
          <h1 className="mb-2 text-2xl font-bold text-black md:text-3xl">Alumni Training Access</h1>
          <p className="text-sm text-gray-600 md:text-base">
            Access archived training modules and register for advanced workshops
          </p>
        </div>

        <div className="mb-6 rounded-lg border border-gray-200 bg-white shadow-sm md:mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex flex-wrap gap-2 px-4 md:gap-0 md:space-x-8 md:px-6">
              <button
                onClick={() => setActiveCourse('business')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeCourse === 'business'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-black'
                }`}
              >
                <span>Design-A-Business</span>
              </button>
              <button
                onClick={() => setActiveCourse('costing')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeCourse === 'costing'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-black'
                }`}
              >
                <span>Introduction to Costing & Management Accounting</span>
              </button>
            </nav>
          </div>

          <div className="p-4 md:p-6">
            {activeCourse === 'business' && <DesignABusiness userRole={userRole} />}
            {activeCourse === 'costing' && <IntroToCostingAndManAcc userRole={userRole} />}
          </div>
        </div>
      </div>
    </div>
  );
};

const sectionPlaceholders = {
  training: <AlumniTraining />,

  health: <HealthDashboard userRole="alumni" />,
  'program-health-check': <HealthDashboard userRole="alumni" />,

  funding: (
    <div className="mx-auto max-w-5xl space-y-6 p-4 md:space-y-8 md:p-6">
      <GrantBasics userRole="alumni" />
      <ApplicationTutorials userRole="alumni" />
    </div>
  ),

  dashboard: <AluminiCRM />,

  'scaling-modules': <ScalingModules userRole="alumni" />,

  crm: <AluminiCRM />,

  weeklyreports: <WeeklyReportsUpload />,
  'alumni-reports': <AlumniReports />,
  'document-bank': <DocumentBankPage />,
  settings: <SettingsPageComponent />,
};

const AluminiDashboard = ({ user }) => {
  const { logout } = useAuth();
  const [selected, setSelected] = useState('dashboard');
  const [collapsed, setCollapsed] = useState(true);
  const [inboxSubsection, setInboxSubsection] = useState('inbox');
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setCollapsed(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderContent = () => {
    switch (selected) {
      case 'dashboard':
        return <AluminiHome />;
      case 'communication':
        return <AluminiCommunication inboxSubsection={inboxSubsection} />;
      case 'profile':
        return <AluminiProfile />;
      case 'settings':
        return <AluminiSettings />;
      default:
        return <AluminiHome />;
    }
  };

  const confirmLogout = async () => {
    setShowLogoutConfirm(false);
    await logout();
  };

  return (
    <div className="flex h-screen overflow-hidden bg-white">
      <AluminiSidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        selected={selected}
        setSelected={setSelected}
        inboxSubsection={inboxSubsection}
        onInboxSubsectionChange={setInboxSubsection}
      />
      <div className="relative flex min-w-0 flex-1 flex-col">
        <AluminiHeader collapsed={collapsed} setCollapsed={setCollapsed} />
        <main className="flex-1 overflow-y-auto bg-transparent p-2 md:p-4">{renderContent()}</main>
      </div>
      <LogoutConfirmation
        isOpen={showLogoutConfirm}
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutConfirm(false)}
      />
    </div>
  );
};

export default AluminiDashboard;
